import React from 'react'
import { Link } from 'react-router-dom';
import "./thanks.scss"

export default function Thanks() {
  return (
    <div className='thanks--container'>
      <div className='thanks'>
        <h1>Thanks for joining the wait list</h1>
        <Link className='back--link' to='/' >&#60; Back home</Link>
      </div>
    </div>
  )
}

// style={{ textDecoration: "none", color: "#000" }}